import { createApi } from '@reduxjs/toolkit/query/react';

import NotesProps, { INotation } from '@/interfaces/notes';
import { IPaginationParams, IPaginationResponse } from '@/interfaces/pagination';

import { axiosBaseQuery } from './query';

export const notesApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'notesApi',
  endpoints(build) {
    return {
      getNotes: build.query<INotation, string | undefined>({
        query: lessonId => ({
          formatResponse: response => response.data.data,
          url: `/learner/lessons/${lessonId}/notation`
        })
      }),
      getAllNotations: build.query<IPaginationResponse<NotesProps[]>, Partial<IPaginationParams>>({
        forceRefetch({ currentArg, previousArg }) {
          return JSON.stringify(currentArg) !== JSON.stringify(previousArg);
        },
        serializeQueryArgs: ({ endpointName }) => {
          return endpointName;
        },
        merge: (currCache, newCache) => {
          currCache.total_pages = newCache.total_pages;
          currCache.page = newCache.page;
          currCache.links = newCache.links;

          if (newCache.page.page === 1) {
            currCache.data = newCache.data;
          } else {
            currCache.data.push(...newCache.data);
          }
        },
        query: params => ({
          url: '/learner/notations',
          params
        })
      }),
      sendNotes: build.mutation<INotation, { lessonId: string; text: string }>({
        query: ({ lessonId, text }) => ({
          method: 'POST',
          url: `/learner/lessons/${lessonId}/notation`,
          data: {
            text
          }
        })
      })
    };
  }
});

export const { useGetNotesQuery, useGetAllNotationsQuery, useSendNotesMutation } = notesApi;
